import React, { Component } from 'react'
import { MainNavigation, MainNavigationItem, Link, User } from '@wfp/ui'
import { NavLink } from 'react-router-dom'
import { connect } from 'react-redux'
import {API_HOST, API_URL} from '../api';

class Header extends Component {
  render() {
    if (!this.props.email) return null
    const adminStyle = this.props.isRmp ? {} : { display: 'None' }
    console.log(API_HOST)
    return (
      <MainNavigation
        ref={instance => {
          this.child = instance
        }}
        logo={
          <NavLink className={'wfp--link'} to={'/index/'}>
            COMP Narratives
          </NavLink>
        }
        pageWidth='lg'>
        <MainNavigationItem>
          <NavLink className={'wfp--link'} to={'/dashboard/'}>
            Dashboard
          </NavLink>
        </MainNavigationItem>
        <MainNavigationItem>
          <Link style={adminStyle} href={API_HOST}>
            Admin
          </Link>
        </MainNavigationItem>
        <MainNavigationItem>
          <NavLink className={'wfp--link'} to={'/faq/'}>
            FAQ
          </NavLink>
        </MainNavigationItem>
        <MainNavigationItem>
          <User name={this.props.fullName} image={`${API_URL}user_image/?email=${this.props.email}`} />
        </MainNavigationItem>
        <MainNavigationItem>
          <Link href='/logout/?next=/bye/'>Logout</Link>
        </MainNavigationItem>
      </MainNavigation>
    )
  }
}

const mapStateToProps = state => ({
  fullName: state.appSettings.userInfo ? state.appSettings.userInfo.full_name : null,
  email: state.appSettings.userInfo ? state.appSettings.userInfo.email : null,
  isRmp: state.appSettings.userInfo ? state.appSettings.userInfo.is_rmp : false,
})

const mapDispatchToProps = null

Header = connect(
  mapStateToProps,
  mapDispatchToProps
)(Header)

export default Header
